export default __webpack_public_path__ + "static/media/stopwatch.db25634f.svg";